"use strict";

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _animations = require("@qc-modules/animations");

var _primitives = _interopRequireDefault(require("../../primitives"));

var _utils = require("../../utils");

var _excluded = ["boxShadow", "containerProps", "hideDropdown", "justifyContent", "onClick", "position", "render", "renderDropdown", "selected"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var propTypes = {
  /** shadow prop for dropdown  */
  boxShadow: (0, _propTypes.oneOfType)([(0, _propTypes.arrayOf)(_propTypes.number), _propTypes.number, _propTypes.string]),

  /** props for styling dropdown container */
  containerProps: (0, _propTypes.objectOf)((0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string, _propTypes.number, _propTypes.object])),

  /** hide dropdown boolean */
  hideDropdown: _propTypes.bool,

  /** Dropdown Justify string  */
  justifyContent: _propTypes.string,

  /** Function for useToggle hook  */
  onClick: _propTypes.func,

  /** position prop for drop down container */
  position: (0, _propTypes.oneOfType)([_propTypes.array, _propTypes.string]),

  /** Render prop to create dropdown header  */
  render: _propTypes.func.isRequired,

  /** Content render function for dropdown body  */
  renderDropdown: _propTypes.func.isRequired,

  /** selected tab */
  selected: _propTypes.number,

  /** Internal boolean to feed to the label for active  */
  show: _propTypes.bool,

  /** Internal function to handle toggling active  */
  toggleShowDropdown: _propTypes.func
};

var Dropdown = function Dropdown(_ref) {
  var _ref$boxShadow = _ref.boxShadow,
      boxShadow = _ref$boxShadow === void 0 ? "0px 0px 12px 0px rgba(74,90,117,0.08), 0px 20px 20px -12px rgba(74,90,117,0.24)" : _ref$boxShadow,
      containerProps = _ref.containerProps,
      _ref$hideDropdown = _ref.hideDropdown,
      hideDropdown = _ref$hideDropdown === void 0 ? false : _ref$hideDropdown,
      justifyContent = _ref.justifyContent,
      onClick = _ref.onClick,
      _ref$position = _ref.position,
      position = _ref$position === void 0 ? "relative" : _ref$position,
      render = _ref.render,
      renderDropdown = _ref.renderDropdown,
      _ref$selected = _ref.selected,
      selected = _ref$selected === void 0 ? 0 : _ref$selected,
      rest = _objectWithoutPropertiesLoose(_ref, _excluded);

  var firstRef = (0, _react.useRef)(null);
  var buttonRef = (0, _react.useRef)(null);
  var wrapperRef = (0, _react.useRef)(null);
  /**
   * Callback to toggle dropdown open/closed
   */

  var toggle = (0, _react.useCallback)(function (event, val) {
    if (val && buttonRef.current) {
      buttonRef.current.focus();
    }

    (0, _utils.callIfFunc)(onClick, rest);
  }, [onClick, rest]);

  var _useToggle = (0, _utils.useToggle)(false, toggle),
      show = _useToggle[0],
      toggleShowDropdown = _useToggle[1];
  /**
   * Handle keyboard navigation
   */


  var handleKeydown = (0, _react.useCallback)(function (event) {
    event.preventDefault();

    if (event.key === "Enter") {
      toggleShowDropdown(event);
    }

    if (show && event.key === "Escape") {
      toggleShowDropdown(event);
    }

    if (event.key === "ArrowDown" && firstRef.current) {
      firstRef.current.focus();
    }
  }, [show, toggleShowDropdown]);
  /**
   * Callback to return focus
   */

  var returnFocus = (0, _react.useCallback)(function () {
    if (show && buttonRef.current) {
      buttonRef.current.focus();
    }
  }, [show]);
  /**
   * Hook that observes clicks outside of the passed ref
   */

  var useOutsideToggler = function useOutsideToggler(wrapper) {
    /**
     * Toggle dropdown on click outside
     */
    function handleClickOutside(event) {
      if (show && wrapper.current && !wrapper.current.contains(event.target)) {
        toggleShowDropdown(event);
      }
    }

    (0, _react.useEffect)(function () {
      // Bind the event listener
      document.addEventListener("mousedown", handleClickOutside);
      return function () {
        // Unbind the event listener on clean up
        document.removeEventListener("mousedown", handleClickOutside);
      };
    });
  };

  useOutsideToggler(wrapperRef);
  return /*#__PURE__*/_react["default"].createElement(_primitives["default"].Flex, _extends({
    flexDirection: "column",
    position: position,
    ref: wrapperRef
  }, rest), /*#__PURE__*/_react["default"].createElement(_primitives["default"].Button, {
    alignItems: "center",
    "aria-expanded": show,
    "aria-haspopup": "true",
    justifyContent: justifyContent || "left",
    onClick: toggleShowDropdown,
    onKeyDown: handleKeydown,
    ref: buttonRef,
    style: {
      cursor: "pointer"
    },
    type: "button",
    width: 1
  }, render({
    show: show
  })), !hideDropdown && /*#__PURE__*/_react["default"].createElement(_animations.TransitionHeight, {
    enterDuration: 0.35,
    exitDuration: 0.35,
    fadeInOut: true,
    show: show
  }, /*#__PURE__*/_react["default"].createElement(_primitives["default"].Box, _extends({
    backgroundColor: "white",
    borderRadius: 8,
    boxShadow: boxShadow,
    display: "none",
    height: 0,
    left: 0,
    minWidth: "100%",
    opacity: 0,
    overflow: "hidden",
    position: "absolute",
    role: "menu",
    top: "100%",
    zIndex: 1
  }, containerProps), renderDropdown({
    firstRef: firstRef,
    returnFocus: returnFocus,
    selected: selected,
    show: show,
    toggleShowDropdown: toggleShowDropdown
  }))));
};

Dropdown.propTypes = propTypes;
Dropdown.displayName = "Modules.Dropdown";
var _default = Dropdown;
exports["default"] = _default;